import { Grid, Link, Theme, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Remove'
import { TradeMarkURL } from '@src/routes/Configurators/products/TubesMTORedesign/utils'
import React from 'react'
import { useIntl } from 'react-intl'
import {
  shouldRenderTradeMarkHyperLink,
  useProductFromQueryParam,
} from '../../ProductsConfiguration'

const useStyle = makeStyles((theme: Theme) => {
  return {
    summaryHeading: {
      alignItems: 'center',
      color: theme.palette.common.white,
      display: 'flex',
    },
    summaryHeadingText: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(16),
    },
    summaryHeadingIcon: {
      display: 'flex',
      paddingRight: theme.spacing(3),
    },
    summaryHeadingTradeMark: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 700,
    },
  }
})

interface ModificationsAccordionSummaryProps {
  summary: React.ReactNode
  expanded: boolean
}

const ModificationsAccordionSummary: React.FC<
  ModificationsAccordionSummaryProps
> = ({ summary, expanded }) => {
  const classes = useStyle()
  const intl = useIntl()
  const product = useProductFromQueryParam()
  const renderTradeMarkHyperLink = shouldRenderTradeMarkHyperLink(product)

  return (
    <>
      <Grid item xs={8} className={classes.summaryHeading}>
        <span className={classes.summaryHeadingIcon}>
          {expanded ? (
            <RemoveIcon color="inherit" fontSize="medium" />
          ) : (
            <AddIcon color="inherit" fontSize="medium" />
          )}
        </span>

        <Typography
          className={classes.summaryHeadingText}
          component="span"
          variant="h3"
          data-scrub
        >
          {summary}
        </Typography>
      </Grid>

      {renderTradeMarkHyperLink && (
        <Grid item xs={4}>
          <Grid container justifyContent={'flex-end'}>
            <Link href={TradeMarkURL} target="_blank" rel="noreferrer">
              <Typography
                className={classes.summaryHeadingTradeMark}
                component="span"
                variant="body1"
                data-scrub
              >
                {intl.formatMessage({
                  id: 'CONF_TRADEMARK_LICENSE_INFORMATION',
                  defaultMessage: 'Trademark and Label License Information',
                })}
              </Typography>
            </Link>
          </Grid>
        </Grid>
      )}
    </>
  )
}

export default ModificationsAccordionSummary
